import { createFileRoute } from "@tanstack/react-router";
import { EnvioColaboradorPage } from "@/features/envio-colaborador";

export const Route = createFileRoute("/enviar/$slug")({
  component: RotaEnvio,
});

function RotaEnvio() {
  const { slug } = Route.useParams();
  return <EnvioColaboradorPage slug={slug} />;
}
